import Decimal from 'decimal.js-light';

/**
 * Somma una lista di aree usando Decimal.js per evitare gli errori di
 * arrotondamento dei float nativi (es. 0.1 + 0.2 !== 0.3).
 */
export function sumAreasWithDecimal(
  areas: Array<number | null | undefined>,
): number {
  return areas
    .reduce<Decimal>((total, area) => total.plus(area ?? 0), new Decimal(0))
    .toNumber();
}
